import { render, staticRenderFns } from "./ClienteInfo.vue?vue&type=template&id=6ecea55e&"
import script from "./ClienteInfo.vue?vue&type=script&lang=js&"
export * from "./ClienteInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClienteInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports